import {
  Col,
  Row,
  DropdownMenu,
  DropdownItem,
  Tag,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Image,
  Swipe,
  SwipeItem,
  Sticky,
  Button,
  DatetimePicker,
  Form,
  Field,
  Popup,
  Stepper,
  Icon,
  Collapse,
  CollapseItem,
  Loading,
  Dialog,
  Grid,
  GridItem
} from 'vant'

const vant = {
  install: function (Vue) {
    Vue.use(Col)
    Vue.use(Row)
    Vue.use(DropdownMenu)
    Vue.use(DropdownItem)
    Vue.use(Tag)
    Vue.use(Tab)
    Vue.use(Tabs)
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    Vue.use(Image)
    Vue.use(Swipe)
    Vue.use(SwipeItem)
    Vue.use(Sticky)
    Vue.use(Button)
    Vue.use(DatetimePicker)
    Vue.use(Form)
    Vue.use(Field)
    Vue.use(Popup)
    Vue.use(Stepper)
    Vue.use(Icon)
    Vue.use(Collapse)
    Vue.use(CollapseItem)
    Vue.use(Loading)
    Vue.use(Dialog)
    Vue.use(Grid)
    Vue.use(GridItem)
  }
}

export default vant



// WEBPACK FOOTER //
// ./src/VantUi/vant.js